import styled from "styled-components";

export const PageContainer = styled.div`
    padding: 14px;
    border: 1px solid #dee2e6;
    border-top: none;
`;